import { takeEvery, put } from "redux-saga/effects";

import axios from "axios";

import { unreadMessagesApi } from "../../../utility/api/apiList";

import userMessageType from "./userMessageType";
import { handleSetDetailForUpdate } from "./userMessageAction";

export function* startUpdateUserUnReadMessage(action) {
  try {
    const response = yield axios.get(unreadMessagesApi);
    const setDetail = yield put(
      handleSetDetailForUpdate(response.data.UnReadMessage)
    );
  } catch (error) {}
}

export function* handleUpdateUserUnReadMessage() {
  yield takeEvery(
    userMessageType.UPDATE_COUNT_UNREAD_MESSAGE,
    startUpdateUserUnReadMessage
  );
}
